import { Helmet } from 'react-helmet-async'

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Wispr Flow | Not Found</title>
      </Helmet>
      <div>
        <h1>Not found</h1>
      </div>
    </>
  )
}
